<div class="close" (click)="onModalClosed()"></div>
  <!--<i  (click)="onModalClosed()" class="close"></i>-->
<video id="openVideoFull" class="fullscreen" src={{videoSrc}}  autoplay controls></video>

